// Site Configurations for Shop Pullman Hotels
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import { UtilityIcons } from '@Hotels-at-Home/hah-fe-core/dist/types';

export const csrEmail = 'customer.service@e-shop.pullmanhotels.com';
export const siteName = 'Pullman Hotels Shop';
export const parentHotelCompany = 'Accor'; // "Accor" or "Marriott"
export const hotelBrandName = 'Pullman';
export const catalogId = 'PUL';
export const region = 'EU';

export const scandiWebMenuId = 'pul'; // TODO: Change to 'pul' after scandiweb top menu is created
export const companyTelephone = '+33 (0)1 41 51 55 16';

export const LOGO_IMAGE = { src: '/images/misc/shop-pullman-logo.svg', alt: '' };

export const accorTagging = {
  accorTaggingEnabled: true,
  pageNamePrefix: 'pul',
};

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 970,
  imageHeight: 722,
  imageWidthThumbnail: 500,
  ctaBlackUpsellLink: true,
  counterButtons: true,
  alignCounterWithCartBtn: true,
  breadCrumbPosition: 'top',
  enableAccorRewardsTab: true,
  enableShippingReturnsTab: true,
  addonModalSize: 'sm',
  stickConfigBlock: true,
  almaBanner: true,
  disableDefaultYmal: true,
};

export const category = {
  imageEagerLoadingAmount: 2,
  colorSwitcher: true,
  disableColorSwitcherImageSwitching: true,
  displayPrices: true,
  colorSwitcherMode: 'hover', // 'default' | 'click' | 'hover'
};

export const checkout = {
  radioButtons: true,
  placeholderLabels: true,
  aboveTotalsCouponCode: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
  paymentMethodProceedButton: true,
};
export const footer = {
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
  inlineSubscribeHeading: true,
};
export const header = {
  subMenuImages: true,
  subMenuImageNoWrapper: true,
  shallowMobileMenu: true,
  subMenuImageSize: {
    width: 289,
    height: 144,
  },
  subMenuExtraImageSize: {
    width: 234,
    height: 240,
  },
  textMobileMenuButton: true,
  leftDrawerUtilities: true,
};

export const notFoundPage = {
  button: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 711,
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
};
export const iconOrder = [
  UtilityIcons.Language,
  UtilityIcons.Currency,
  UtilityIcons.Search,
  UtilityIcons.ShoppingCart,
  // UtilityIcons.Account,
];

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
// GTM Owned by Accor
export const googleTagManagerId = 'GTM-NGRBZBXR';
export const productNameFilters = {
  replacements: [{ target: 'Shop Pullman Hotels', replacement: 'Shop' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'vSCp1gGlTNQxglO8BMl8GW8s1jAovJtZ5y2XASKmkIY';
export const defaultOgImage = '/images/homePage/heroSection/hp-main-hero-novotel-mobile.webp'; // TODO: Change to Pullman image

export const account = {
  accountGlobalEnable: true,
  disableAccountDrawer: true,
  enableLogoutBtn: true,
  enableWelcomeMessage: true,
  register: {
    hahSubscribeCheckbox: true,
    brandSubscribeCheckbox: true,
    accorSubscribeCheckbox: true,
  },
};

// We use this to calculate discount on static prices in the HP
// if a different discount needs to be applied to individual products (e.g. in variable promos) in the HP search for "static prices in EUR" and update accordingly
export const sitewideDiscount = 0.25;

export const cart = {
  counterButtons: true,
  drawerContinueShopping: true,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName1: '	PUL - HP - Guest Favorites',
  ymalName2: 'PUL - HP - Bedding',
  ymalName3: 'PUL - HP - Fragrance',
  ymalName4: 'PUL - HP - Bath',
  disableCartYmals: true,
  drawerTotalInBUtton: true,
};
